/* MTL 2026-10-24 (owner "2 yes"): engraving text cleaner. Was: silently deleted every
   character outside [A-Za-z0-9 '-.] (Zoë -> ZO, Chloé -> CHLO, O’Malley -> OMalley, & vanished).
   Now: accents become plain letters (é -> e), curly quotes/dashes become ' and -, the allowed
   set sent to production is UNCHANGED, the length limit is applied after cleaning, and the
   shopper sees a short note whenever their text was changed. ROLLBACK: restore live md5
   a531fcf9 (mtl-personalization.js) / 09035c47 (mtl-personalization-proper.js). */
window.MTLEngraveClean = window.MTLEngraveClean || function (input) {
  if (!input) return;
  var v = input.value || '';
  var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var map = { 'ß': 'ss', 'æ': 'ae', 'Æ': 'AE', 'œ': 'oe', 'Œ': 'OE', 'ø': 'o', 'Ø': 'O', 'ł': 'l', 'Ł': 'L', 'đ': 'd', 'Đ': 'D' };
  var t = v.replace(/[‘’ʼ´`]/g, "'")
           .replace(/[‐-―]/g, '-')
           .replace(/[ßæÆœŒøØłŁđĐ]/g, function (m) { return map[m]; });
  var plain = t.normalize ? t.normalize('NFD').replace(/[̀-ͯ]/g, '') : t;
  var accented = plain !== t;
  var removed = [];
  var out = plain.replace(/[^A-Za-z0-9 '\-.]/g, function (m) { if (removed.indexOf(m) < 0) removed.push(m); return ''; });
  out = out.replace(/ {2,}/g, ' ');
  var max = parseInt(input.getAttribute('maxlength') || '0', 10);
  var cut = false;
  if (max > 0 && out.length > max) { out = out.slice(0, max); cut = true; }
  if (out !== v) {
    var pos = input.selectionStart;
    input.value = out;
    try { if (pos != null) { var p = Math.min(pos, out.length); input.setSelectionRange(p, p); } } catch (_) {}
  }
  var msgs = [];
  if (accented) msgs.push(fr ? 'Les accents sont gravés sans accent (é → e).' : 'Accents are engraved as plain letters (é → e).');
  if (removed.length) msgs.push((fr ? 'Ces caractères ne peuvent pas être gravés et ont été retirés : ' : "These characters can't be engraved and were removed: ") + removed.join(' '));
  if (cut) msgs.push(fr ? ('Nombre maximal de caract\u00e8res\u00a0: ' + max + '.') : ('Maximum ' + max + ' characters.'));
  if (!(input.value || '').length) input._mtlMsgs = [];
  var seen = input._mtlMsgs || (input._mtlMsgs = []);
  for (var k = 0; k < msgs.length; k++) {
    var key = msgs[k].split(':')[0];
    var found = -1;
    for (var j = 0; j < seen.length; j++) { if (seen[j].split(':')[0] === key) found = j; }
    if (found >= 0) seen[found] = msgs[k]; else seen.push(msgs[k]);
  }
  msgs = seen.slice();
  var note = input._mtlNote || null;
  if (msgs.length) {
    if (!note) {
      note = document.createElement('p');
      note.className = 'mtl-engrave-note';
      note.setAttribute('role', 'status');
      note.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.45;color:#7a4b00;background:#fbf3e2;border-radius:6px;padding:8px 10px;';
      var anchor = input.closest('.name-input-wrap, .mtl-name-field, label') || input;
      anchor.parentNode.insertBefore(note, anchor.nextSibling);
      input._mtlNote = note;
    }
    note.textContent = msgs.join(' ');
    note.hidden = false;
  } else if (note && !(input.value || '').length) {
    note.hidden = true;
  }
};

// cache-bump 1782000000
/* CACHE-BUST 2026-06-24T-P0-variant-key-fix */
/* ==========================================================================
   Memory That Lasts — Personalization Section JS
   Handles: metal swatch toggle, name input + char filter + shrink-to-fit,
            cross-product name memory (localStorage), gift message toggle,
            mockup lightbox, "See engraving close-up" link.
   No dependencies. Runs on DOMContentLoaded.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mtlInited === '1') return;
    root.dataset.mtlInited = '1';

    /* --- LAYOUT FIX: defeat Horizon's global .grid 14-col utility ---
       Switch from CSS Grid to Flexbox. Flexbox bypasses Horizon's grid-template
       conflict entirely. Widths set on children via flex shorthand. */
    const gridDiv = root.querySelector(':scope > .grid, :scope > .mtl-grid');
    if (gridDiv) {
      const mediaCol = gridDiv.querySelector(':scope > .media, :scope > .mtl-media');
      const copyCol = gridDiv.querySelector(':scope > .copy, :scope > .mtl-copy');
      function applyFlexLayout() {
        if (window.innerWidth >= 990) {
          gridDiv.style.setProperty('display', 'flex', 'important');
          gridDiv.style.setProperty('flex-direction', 'row', 'important');
          gridDiv.style.setProperty('gap', '56px', 'important');
          gridDiv.style.setProperty('align-items', 'flex-start', 'important');
          if (mediaCol) {
            mediaCol.style.setProperty('flex', '1.05 1 0', 'important');
            mediaCol.style.setProperty('min-width', '0', 'important');
            mediaCol.style.setProperty('width', 'auto', 'important');
          }
          if (copyCol) {
            copyCol.style.setProperty('flex', '1 1 0', 'important');
            copyCol.style.setProperty('min-width', '0', 'important');
            copyCol.style.setProperty('width', 'auto', 'important');
          }
        } else {
          gridDiv.style.setProperty('display', 'flex', 'important');
          gridDiv.style.setProperty('flex-direction', 'column', 'important');
          gridDiv.style.setProperty('gap', '24px', 'important');
          if (mediaCol) {
            mediaCol.style.setProperty('flex', '0 0 auto', 'important');
            mediaCol.style.setProperty('width', '100%', 'important');
          }
          if (copyCol) {
            copyCol.style.setProperty('flex', '0 0 auto', 'important');
            copyCol.style.setProperty('width', '100%', 'important');
          }
        }
      }
      applyFlexLayout();
      window.addEventListener('resize', applyFlexLayout);
    }

    /* --- SWATCH FIX: defeat Horizon's .swatch class collision ---
       Sets the BUTTON dimensions + circle + labels via inline !important. */
    function applySwatchStyles() {
      const isMobile = window.innerWidth <= 989;
      // Both viewports use vertical stack (circle on top, name below, sub smaller below).
      // Mobile is just smaller — everything scales down proportionally.
      const CIRCLE_SIZE = isMobile ? 28 : 36;  // 2026-07-30: mobile 20 -> 28, easier to see + tap
      const SWATCH_DIR  = 'column';  /* always vertical stack */
      const SWATCH_GAP  = isMobile ? 4 : 10;  /* gap between circle and label */
      const SWATCH_MIN_W = isMobile ? 60 : 80;  /* give each swatch a min width so they're evenly distributed */
      const SWATCH_MIN_H = isMobile ? 0 : 90;
      const CONTAINER_GAP = isMobile ? 18 : 24;  /* space between Gold and Silver swatches */

      // Container spacing
      const swatchContainer = root.querySelector('.swatches');
      if (swatchContainer) {
        swatchContainer.style.setProperty('display', 'flex', 'important');
        swatchContainer.style.setProperty('flex-direction', 'row', 'important');
        swatchContainer.style.setProperty('gap', CONTAINER_GAP + 'px', 'important');
        swatchContainer.style.setProperty('padding', isMobile ? '0' : '8px 0', 'important');
        swatchContainer.style.setProperty('align-items', 'center', 'important');
        // On mobile: sit right next to label with fixed 18px gap, NOT flex-end (which clips off-screen)
        // On desktop: natural left-flow under the label
        /* 2026-10-22 FIX: when the mobile stacked-finish CSS gives the swatch row a full-width basis
           (2-finish sliding-bar / break-apart PDPs), an 18px inline margin pushed it 2px past a 390px
           screen (sideways scroll). Use 0 in that case, matching the section CSS intent. SAFE TO REVERT. */
        var mtlFullRow = isMobile && getComputedStyle(swatchContainer).flexBasis === '100%';
        swatchContainer.style.setProperty('margin-left', (isMobile && !mtlFullRow) ? '18px' : '0', 'important');
        swatchContainer.style.setProperty('justify-content', 'flex-start', 'important');
        /* 3-FINISH MOBILE FIX (2026-06-08, owner-approved): a 3rd finish (Rose Gold) overflows the
           inline label+swatch row on mobile and clips finishes off-screen. For 3+ swatches on mobile
           ONLY, wrap the swatch row to its own full-width line below the label so all finishes are
           visible + tappable. 2-finish PDPs are untouched (condition gates it). */
        var mtlSwatchCount = root.querySelectorAll('[data-mtl-swatch]').length;
        var mtlStepFinish = swatchContainer.closest('.step-finish') || swatchContainer.parentElement;
        if (isMobile && mtlSwatchCount >= 3 && mtlStepFinish) {
          mtlStepFinish.style.setProperty('flex-wrap', 'wrap', 'important');
          swatchContainer.style.setProperty('flex-basis', '100%', 'important');
          swatchContainer.style.setProperty('margin-left', '0', 'important');
          swatchContainer.style.setProperty('margin-top', '10px', 'important');
          swatchContainer.style.setProperty('justify-content', 'space-around', 'important');
        }
      }
      root.querySelectorAll('[data-mtl-swatch]').forEach((swatch) => {
        swatch.style.setProperty('display', 'flex', 'important');
        swatch.style.setProperty('flex-direction', SWATCH_DIR, 'important');
        swatch.style.setProperty('align-items', 'center', 'important');
        swatch.style.setProperty('gap', SWATCH_GAP + 'px', 'important');
        swatch.style.setProperty('min-width', SWATCH_MIN_W + 'px', 'important');
        swatch.style.setProperty('min-height', SWATCH_MIN_H + 'px', 'important');
        swatch.style.setProperty('padding', isMobile ? '4px 4px' : '4px', 'important');
        swatch.style.setProperty('background', 'none', 'important');
        swatch.style.setProperty('border', 'none', 'important');
        swatch.style.setProperty('cursor', 'pointer', 'important');
        // No pill background — selection is indicated purely by the circle's border ring
        // (keeps vertical rhythm identical between selected and unselected swatches)
        swatch.style.setProperty('border-radius', '8px', 'important');
        swatch.style.setProperty('background', 'none', 'important');
        // Name label — vertical stack with circle on top, centered text below
        const name = swatch.querySelector('.swatch-name');
        if (name) {
          name.style.setProperty('display', 'flex', 'important');
          name.style.setProperty('flex-direction', 'column', 'important');
          name.style.setProperty('align-items', 'center', 'important');
          name.style.setProperty('gap', isMobile ? '1px' : '0', 'important');
          name.style.setProperty('font-size', isMobile ? '10px' : '12px', 'important');
          name.style.setProperty('font-weight', '600', 'important');
          name.style.setProperty('color', '#1a1a1a', 'important');
          name.style.setProperty('text-align', 'center', 'important');
          name.style.setProperty('line-height', isMobile ? '1.1' : '1.3', 'important');
          name.style.setProperty('letter-spacing', '.02em', 'important');
          name.style.setProperty('white-space', 'nowrap', 'important');
          name.style.setProperty('overflow', 'visible', 'important');
        }
        // Sub label: ALWAYS show — honest material spec, centered under the name
        const sub = swatch.querySelector('.swatch-sub');
        if (sub) {
          sub.style.setProperty('display', 'block', 'important');
          sub.style.setProperty('font-size', isMobile ? '8px' : '10px', 'important');
          sub.style.setProperty('color', isMobile ? '#8a8a8a' : '#9a9a9a', 'important');
          sub.style.setProperty('font-weight', '400', 'important');
          sub.style.setProperty('margin-top', '0', 'important');
          sub.style.setProperty('text-align', 'center', 'important');
          sub.style.setProperty('line-height', '1.1', 'important');
          sub.style.setProperty('letter-spacing', '.02em', 'important');
          sub.style.setProperty('white-space', 'nowrap', 'important');
        }
        const circle = swatch.querySelector('.swatch-circle');
        if (!circle) return;
        const metal = swatch.getAttribute('data-mtl-swatch');
        let gradient = '';
        if (metal === 'gold') {
          gradient = 'radial-gradient(circle at 30% 30%, #f4d68a 0%, #d4af37 45%, #a8810e 100%)';
        } else if (metal === 'silver') {
          gradient = 'radial-gradient(circle at 30% 30%, #f5f5f5 0%, #c0c0c0 45%, #8a8a8a 100%)';
        } else if (metal === 'rosegold') {
          gradient = 'radial-gradient(circle at 30% 30%, #f8d0c2 0%, #e8a596 45%, #b87d6e 100%)';
        }
        circle.style.setProperty('width', CIRCLE_SIZE + 'px', 'important');
        circle.style.setProperty('height', CIRCLE_SIZE + 'px', 'important');
        circle.style.setProperty('min-height', CIRCLE_SIZE + 'px', 'important');
        circle.style.setProperty('max-height', CIRCLE_SIZE + 'px', 'important');
        circle.style.setProperty('min-width', CIRCLE_SIZE + 'px', 'important');
        circle.style.setProperty('max-width', CIRCLE_SIZE + 'px', 'important');
        circle.style.setProperty('border-radius', '50%', 'important');
        circle.style.setProperty('display', 'block', 'important');
        circle.style.setProperty('flex-shrink', '0', 'important');
        circle.style.setProperty('background', gradient, 'important');
        circle.style.setProperty('border', isMobile ? '1.5px solid transparent' : '2px solid transparent', 'important');
        const shadowScale = isMobile ? 0.55 : 1;
        const baseShadow = `inset ${-5*shadowScale}px ${-5*shadowScale}px ${10*shadowScale}px rgba(0,0,0,.18), inset ${5*shadowScale}px ${5*shadowScale}px ${10*shadowScale}px rgba(255,255,255,.30), 0 1px 2px rgba(0,0,0,.08)`;
        if (swatch.classList.contains('active')) {
          // Selection ring: gold-tinted halo around the circle, no background change on the swatch
          circle.style.setProperty('border-color', '#9d8349', 'important');
          circle.style.setProperty('box-shadow', `${baseShadow}, 0 0 0 2px rgba(157, 131, 73, 0.3)`, 'important');
        } else {
          circle.style.setProperty('box-shadow', baseShadow, 'important');
        }
      });
    }
    applySwatchStyles();
    window.addEventListener('resize', applySwatchStyles);
    root.querySelectorAll('[data-mtl-swatch]').forEach((btn) => {
      btn.addEventListener('click', () => setTimeout(applySwatchStyles, 10));
    });

    /* --- PREMIUM POLISH: accordion + pendant sizing + type refinement ---
       Premium jewelry spacing reference. */
    function applyPremiumPolish() {
      // Pendant sizing — LET THE WRAPPER GROW to fit pendant + mockup strip below.
      // Only cap the IMAGE portion; wrapper grows to contain strip.
      const pendantWrap = root.querySelector('.pendant-wrap');
      if (pendantWrap) {
        pendantWrap.style.setProperty('max-height', 'none', 'important');
        pendantWrap.style.setProperty('overflow', 'visible', 'important');
      }
      // Cap ONLY the image area (keeps 1:1 aspect, leaves room for strip below)
      const pendantImgWrap = root.querySelector('.pendant-img-wrap');
      if (pendantImgWrap) {
        pendantImgWrap.style.setProperty('aspect-ratio', '1 / 1', 'important');
        pendantImgWrap.style.setProperty('max-height', window.innerWidth < 990 ? '50vh' : '440px', 'important');
        pendantImgWrap.style.setProperty('overflow', 'hidden', 'important');
        pendantImgWrap.style.setProperty('border-radius', '18px 18px 0 0', 'important');
      }
      // NUKE the legacy duplicate .mtl-gift-wrap element (old liquid iteration left it in live theme)
      const dupGift = root.querySelector('.mtl-gift-wrap');
      if (dupGift) {
        dupGift.style.setProperty('display', 'none', 'important');
        dupGift.remove();  // Belt + suspenders
      }
      // Center the mockup thumbnail strip (was left-aligned) + ensure visible.
      // MTL 2026-07-28 (gallery-fix): all product mockups now render (not just 4).
      // When they overflow the strip width, left-align + snap-scroll and flag the row
      // so a right-edge "more" fade appears, telling customers to scroll for the rest.
      const mockupStrip = root.querySelector('.mockup-strip');
      if (mockupStrip) {
        mockupStrip.style.setProperty('display', 'flex', 'important');
        mockupStrip.style.setProperty('gap', '10px', 'important');
        mockupStrip.style.setProperty('padding', '14px 0 4px', 'important');
        mockupStrip.style.setProperty('flex-wrap', 'nowrap', 'important');
        mockupStrip.style.setProperty('overflow-x', 'auto', 'important');
        mockupStrip.style.setProperty('scroll-snap-type', 'x proximity', 'important');
        mockupStrip.querySelectorAll('.mockup-thumb').forEach(function (t) {
          t.style.setProperty('scroll-snap-align', 'start');
        });
        const mtlStripRow = mockupStrip.closest('.mockup-strip-row') || mockupStrip.parentElement;
        const applyStripFit = function () {
          const over = mockupStrip.scrollWidth > mockupStrip.clientWidth + 2;
          mockupStrip.style.setProperty('justify-content', over ? 'flex-start' : 'center', 'important');
          if (mtlStripRow) mtlStripRow.classList.toggle('mtl-strip--has-more', over);
        };
        const applyStripEnd = function () {
          if (!mtlStripRow) return;
          const atEnd = mockupStrip.scrollLeft + mockupStrip.clientWidth >= mockupStrip.scrollWidth - 4;
          mtlStripRow.classList.toggle('mtl-strip--scrolled-end', atEnd);
        };
        applyStripFit();
        window.addEventListener('resize', applyStripFit);
        mockupStrip.addEventListener('scroll', applyStripEnd, { passive: true });
      }
      // Price — shrink to pull ATC up so it aligns with bottom of live preview card.
      // Horizon's .price utility overrides our CSS; inline style beats it.
      const priceEl = root.querySelector('.price');
      if (priceEl) {
        priceEl.style.setProperty('font-family', "'Playfair Display', serif", 'important');
        priceEl.style.setProperty('font-size', '20px', 'important');
        priceEl.style.setProperty('line-height', '1.2', 'important');
        priceEl.style.setProperty('font-weight', '500', 'important');
        priceEl.style.setProperty('font-style', 'italic', 'important');
        priceEl.style.setProperty('margin', '0 0 14px 0', 'important');
        priceEl.style.setProperty('padding', '0', 'important');
      }
      // Also tighten the kicker label + title margins for compact vertical rhythm
      const kicker = root.querySelector('.kicker');
      if (kicker) kicker.style.setProperty('margin-bottom', '8px', 'important');
      const title = root.querySelector('.mtl-p .product-title, .mtl-p h1');
      if (title) {
        title.style.setProperty('margin', '0 0 10px 0', 'important');
        title.style.setProperty('line-height', '1.15', 'important');
      }

      // 2026-05-30 — respect template's force_uppercase setting (was unconditional).
      // When force_uppercase=false (Cross Bar, Heart Bar — Inter/Dancing Script proper-case
      // engraving), don't force uppercase on the input either; show exactly what's typed.
      const nameInput = root.querySelector('[data-mtl="name-input"]');
      if (nameInput && root.dataset.uppercase !== 'false') {
        nameInput.style.setProperty('text-transform', 'uppercase', 'important');
        nameInput.style.setProperty('letter-spacing', '.05em', 'important');
      } else if (nameInput) {
        // Explicitly clear any prior uppercase inline styles + reset spacing
        nameInput.style.setProperty('text-transform', 'none', 'important');
        nameInput.style.setProperty('letter-spacing', 'normal', 'important');
      }

      // Accordion — hairline dividers, refined typography, smooth spacing
      const pd = root.querySelector('.product-details');
      if (pd) {
        pd.style.setProperty('margin-top', '32px', 'important');
        pd.style.setProperty('border-top', '1px solid rgba(26,26,26,.08)', 'important');
        pd.style.setProperty('display', 'block', 'important');
        pd.style.setProperty('width', '100%', 'important');
      }
      root.querySelectorAll('.product-details details').forEach(d => {
        d.style.setProperty('border-bottom', '1px solid rgba(26,26,26,.08)', 'important');
        d.style.setProperty('display', 'block', 'important');  // ← FIX: stack vertically, not inline
        d.style.setProperty('width', '100%', 'important');
        d.style.setProperty('margin', '0', 'important');
      });
      root.querySelectorAll('.product-details summary').forEach(s => {
        s.style.setProperty('padding', '18px 4px', 'important');
        s.style.setProperty('font-family', "'Inter', sans-serif", 'important');
        s.style.setProperty('font-size', '11.5px', 'important');
        s.style.setProperty('font-weight', '600', 'important');
        s.style.setProperty('letter-spacing', '.14em', 'important');
        s.style.setProperty('text-transform', 'uppercase', 'important');
        s.style.setProperty('color', '#1a1a1a', 'important');
        s.style.setProperty('cursor', 'pointer', 'important');
        s.style.setProperty('list-style', 'none', 'important');
        s.style.setProperty('display', 'flex', 'important');
        s.style.setProperty('justify-content', 'space-between', 'important');
        s.style.setProperty('align-items', 'center', 'important');
        s.style.setProperty('user-select', 'none', 'important');
      });
      root.querySelectorAll('.product-details .details-body').forEach(b => {
        b.style.setProperty('padding', '0 4px 20px', 'important');
        b.style.setProperty('font-family', "'Inter', sans-serif", 'important');
        b.style.setProperty('font-size', '13.5px', 'important');
        b.style.setProperty('line-height', '1.7', 'important');
        b.style.setProperty('color', '#555', 'important');
      });

      // Section rhythm — refined spacing between steps/ATC/trust
      const trust = root.querySelector('.trust-row');
      if (trust) {
        trust.style.setProperty('margin-top', '24px', 'important');
        trust.style.setProperty('padding', '20px 0', 'important');
        trust.style.setProperty('border-top', '1px solid rgba(26,26,26,.08)', 'important');
        trust.style.setProperty('border-bottom', '1px solid rgba(26,26,26,.08)', 'important');
      }
    }
    applyPremiumPolish();
    window.addEventListener('resize', applyPremiumPolish);

    const nameInput   = root.querySelector('[data-mtl="name-input"]');
    const nameText    = root.querySelector('[data-mtl="name-text"]');
    const counter     = root.querySelector('[data-mtl="counter"]');
    const pendantImg  = root.querySelector('[data-mtl="pendant-img"]');
    const atcBtn      = root.querySelector('[data-mtl="atc-btn"]');
    const metalInput  = root.querySelector('[data-mtl="metal-input"]');  // hidden input name="properties[Metal]"
    const isGift      = root.querySelector('[data-mtl="is-gift"]');
    const giftWrap    = root.querySelector('[data-mtl="gift-wrap"]');
    const giftMessage = root.querySelector('[data-mtl="gift-message"]');
    const giftCounter = root.querySelector('[data-mtl="gift-counter"]');
    const lightbox    = root.querySelector('[data-mtl="lightbox"]');
    const lightboxImg = root.querySelector('[data-mtl="lightbox-img"]');
    const lightboxClose = root.querySelector('[data-mtl="lightbox-close"]');

    const MAX_LEN     = parseInt(root.dataset.charLimit || '10', 10);
    let MAX_WIDTH   = parseInt(root.dataset.textWidth || '580', 10);   // let: font picker may override per font
    let BASE_SIZE   = parseInt(root.dataset.baseFontSize || '125', 10);
    const MIN_SIZE    = parseInt(root.dataset.minFontSize || '60', 10) || 60;
    const PRICE       = root.dataset.price || '$0.00';
    const IMG_GOLD    = root.dataset.imgGold;
    const IMG_SILVER  = root.dataset.imgSilver;
    const IMG_ROSE    = root.dataset.imgRosegold;

    let currentMetal = root.dataset.metal || 'gold';
    let currentName  = '';

    /* --- metal swatch toggle --- */
    const HIDE_NAME_STEP = root.dataset.hideNameStep === 'true';
    // Per-SKU case: default ALL-CAPS preview; data-uppercase="false" shows the exact case typed
    // (so the preview matches proper-case engraving fonts like Inter / Dancing Script).
    const FORCE_UPPER = root.dataset.uppercase !== 'false';
    const variantIdInput = root.querySelector('input[name="id"]');

    // Sync defense: at page load, if pre-engraved mode, force the form's variant_id
    // to match the visually-active swatch. Otherwise an admin-side default-variant
    // mismatch could cause "Customer sees Gold selected, cart receives Rose Gold."
    if (variantIdInput) {  /* MTL: align form variant id to active swatch for ALL SKUs */
      const activeSwatch = root.querySelector('[data-mtl-swatch].active') || root.querySelector('[data-mtl-swatch]');
      const desiredVariant = activeSwatch?.getAttribute('data-variant-id');
      if (desiredVariant && desiredVariant !== variantIdInput.value) {
        variantIdInput.value = desiredVariant;
      }
      // Also swap pendant img to the active swatch's image, in case Liquid render
      // picked a different default than the active swatch.
    }
    // MTL 2026-11-02: keep properties[Metal], data-metal and the preview photo in step with the active
    // swatch on load. Before this, a ?variant=<steel or rose> link posted Metal "Gold (18K PVD)" (the Liquid
    // default) unless the shopper tapped a swatch. Only changes anything when the active swatch is not gold.
    (function syncMetalToActiveSwatchOnLoad() {
      const act = root.querySelector('[data-mtl-swatch].active');
      const m = act && act.getAttribute('data-mtl-swatch');
      if (!m) return;
      if (metalInput) metalInput.value = metalFormalName(m);
      if (m === currentMetal) return;
      currentMetal = m;
      root.dataset.metal = m;
      if (pendantImg && !HIDE_NAME_STEP) {
        const src = m === 'silver' ? IMG_SILVER : (m === 'rosegold' ? IMG_ROSE : IMG_GOLD);
        if (src && pendantImg.getAttribute('src') !== src) pendantImg.src = src;
      }
    })();

    // MTL 2026-05-31 — Variant-image decoration for personalized OLD-pipeline.
    // Cross Bar (and any future multi-variant personalized SKU) renders static
    // metal swatches via Liquid that carry data-variant-id but NOT data-image-url.
    // The legacy swatch click handler honored data-image-url only on HIDE_NAME_STEP
    // (pre-engraved) and fell back to the 3 section-setting images for personalized
    // SKUs. Section settings drift from variant.image bindings → image #2 stuck on
    // Gold when user clicked Silver. Fix: fetch /products/{handle}.js once, decorate
    // each personalized swatch with data-image-url from variant.featured_image.
    // Pre-engraved (Cat/Dog Mom): Liquid already populates data-image-url → no-op.
    // Single-variant SKUs (Hidden Message etc): no per-metal variant matched → no
    // decoration → handler falls through to IMG_GOLD/SILVER/ROSE — unchanged behavior.
    (function decorateSwatchesFromVariantImages() {
      if (HIDE_NAME_STEP) return;
      const swatches = root.querySelectorAll('[data-mtl-swatch][data-variant-id]:not([data-image-url])');
      if (!swatches.length) return;
      const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
        .then((res) => res.ok ? res.json() : null)
        .then((product) => {
          if (!product || !Array.isArray(product.variants)) return;
          swatches.forEach((sw) => {
            const vid = sw.getAttribute('data-variant-id');
            const v = product.variants.find((x) => String(x.id) === String(vid));
            if (v && v.featured_image && v.featured_image.src) {
              const base = v.featured_image.src;
              const sep  = base.includes('?') ? '&' : '?';
              sw.setAttribute('data-image-url', base + sep + 'width=1200');
            }
          });
          // After decoration: if the currently-active swatch now has an image URL,
          // sync pendant immediately so the right metal shows even before any click.
          const activeSwatch = root.querySelector('[data-mtl-swatch].active');
        })
        .catch(() => { /* silent — fallback path (IMG_GOLD/SILVER/ROSE) still works */ });
    })();

    root.querySelectorAll('[data-mtl-swatch]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-mtl-swatch]').forEach((b) => {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        currentMetal = btn.getAttribute('data-mtl-swatch');
        root.dataset.metal = currentMetal;
        if (metalInput) metalInput.value = metalFormalName(currentMetal);

        // Pre-engraved (Cat/Dog Mom): swatches map to real product variants.
        // Update the cart form's variant id so ATC submits the right SKU,
        // and swap the pendant image to that variant's photo.
        const swatchVariantId = btn.getAttribute('data-variant-id');
        const swatchImageUrl  = btn.getAttribute('data-image-url');
        if (swatchVariantId && variantIdInput) {  /* MTL: record the chosen finish's real variant id */
          variantIdInput.value = swatchVariantId;
          // MTL 2026-05-31: dispatch change so any Horizon listener catches it.
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (pendantImg) {
          // MTL 2026-05-31: drop HIDE_NAME_STEP gate — honor data-image-url whenever
          // it's present (decorated at boot for personalized multi-variant SKUs;
          // rendered by Liquid for pre-engraved). Section-setting images remain the
          // fallback for single-variant personalized SKUs.
          if (HIDE_NAME_STEP && swatchImageUrl) {
            pendantImg.src = swatchImageUrl;
          } else if (currentMetal === 'gold' && IMG_GOLD) pendantImg.src = IMG_GOLD;
          else if (currentMetal === 'silver' && IMG_SILVER) pendantImg.src = IMG_SILVER;
          else if (currentMetal === 'rosegold' && IMG_ROSE) pendantImg.src = IMG_ROSE;
        }
        // MTL 2026-05-31: if a lifestyle-thumb overlay is currently up, hide it so
        // the pendant swap is visible. (Otherwise overlay sits on top of pendantImg
        // and user sees "no change" after clicking a swatch.)
        const overlayEl = root.querySelector('.mtl-mockup-overlay');
        if (overlayEl && overlayEl.style.display !== 'none') {
          overlayEl.style.display = 'none';
          const liveThumbEl = root.querySelector('.mockup-thumb.live-indicator')
                            || root.querySelector('button.mockup-thumb:not([data-src])');
          if (liveThumbEl) liveThumbEl.classList.add('active');
          root.querySelectorAll('[data-mtl="mockup-thumb"]').forEach((b) => b.classList.remove('active'));
        }
      });
    });

    function metalFormalName(m) {
      return m === 'gold' ? 'Gold (18K PVD)' :
             m === 'silver' ? 'Stainless Steel' :
             m === 'rosegold' ? 'Rose Gold (18K PVD)' :
             m;
    }

    /* ====================================================================
       MTL Font picker — additive, gated on presence of [data-mtl="font-swatches"].
       Only Initials Necklace template has this UI; all other personalized SKUs
       skip this block entirely (no font swatches → no listeners attached).

       Wiring:
         1. font-swatch click → swap SVG <text> font-family + font-weight, rerun
            shrink-to-fit (each font has different optical sizing).
         2. Write properties[Font] hidden input so the cart line item carries
            the chosen font label (Romantic / Timeless / Minimalist).
         3. Look up the 9-way (Color × Font) Shopify variant id from the JSON
            map emitted by Liquid, and update the cart form's id input.

       Hard rule from CLAUDE.md: variant lookup keys MUST match Shopify
       option1/option2 LOWERCASED. The Liquid that emits the map already does
       this; the JS just lowercases its lookup values to match.
       ==================================================================== */
    const fontSwatches    = root.querySelectorAll('[data-mtl="font-swatches"] [data-mtl-font]');
    const fontInput       = root.querySelector('[data-mtl="font-input"]');
    const variantMapEl    = root.querySelector('script[data-mtl="variant-map"]');
    let   variantLookup   = null;
    if (variantMapEl) {
      try { variantLookup = JSON.parse(variantMapEl.textContent || '{}'); }
      catch (_) { variantLookup = null; }
    }
    let currentFontLabel  = fontInput ? fontInput.value : null;
    let currentColorLabel = null;

    // Map our internal metal keys (gold/silver/rosegold) → Shopify Color option
    // strings, lowercased. Returns an ARRAY of candidate values to handle both
    // the legacy spelling and the canonical 2026-06-19 rename:
    //   Canonical (new):  "18K Gold (PVD Coating)" / "18K Rose Gold (PVD Coating)" / "Stainless Steel"
    //   Legacy (pre-rename):  "18K Gold PVD coating" / "18K Rose Gold PVD coating" / "Stainless Steel (No coating)"
    // Forward-compatible: variant-map keys come from Liquid `variant.option1 | downcase`,
    // so whichever spelling the product currently carries, one of these candidates wins.
    function metalToColorCandidates(m) {
      if (m === 'gold')     return ['18k gold (pvd coating)', '18k gold pvd coating'];
      if (m === 'rosegold') return ['18k rose gold (pvd coating)', '18k rose gold pvd coating'];
      if (m === 'silver')   return ['stainless steel', 'stainless steel (no coating)'];
      return [];
    }

    function syncTwoOptionVariantId() {
      if (!variantLookup || !variantIdInput) return;
      const colors = metalToColorCandidates(currentMetal);
      if (!colors.length) return;  // P0 fix 2026-06-24: removed !font guard
      const font = (currentFontLabel || '').toLowerCase();
      let vid = null;
      for (var i = 0; i < colors.length; i++) {
        // 1. Try full 2D key (color × font) — for true multi-option products
        //    where Font is a Shopify variant option (opt2 is non-empty in Liquid).
        if (font) {
          const key2d = colors[i] + '||' + font;
          if (variantLookup[key2d]) { vid = variantLookup[key2d]; break; }
        }
        // 2. Fallback: color||'' — for single-option products where Font is a
        //    line-item property only. Liquid opt2 is nil → key is "color||".
        //    FIX: Initials Necklace has 1 variant option (Color only), so the
        //    map emits "18k gold (pvd coating)||" not "...||romantic".
        const key1d = colors[i] + '||';
        if (variantLookup[key1d]) { vid = variantLookup[key1d]; break; }
      }
      if (vid && String(vid) !== variantIdInput.value) {
        variantIdInput.value = String(vid);
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (fontSwatches.length) {
      // Initialize current values from the active swatch + active font.
      const initialActive = root.querySelector('[data-mtl-swatch].active');
      if (initialActive) currentMetal = initialActive.getAttribute('data-mtl-swatch') || currentMetal;
      const initialFont = root.querySelector('[data-mtl-font].active') || fontSwatches[0];
      currentFontLabel = initialFont.getAttribute('data-mtl-font') || 'Romantic';
      if (fontInput) fontInput.value = currentFontLabel;
      // Apply initial font to the preview text immediately so the customer sees
      // the chosen font on first paint (not a Dancing-Script flash).
      applyFontToPreview(initialFont);
      if (typeof updateName === 'function') { try { updateName(); } catch (_) {} }  // size the default text for the chosen font
      syncTwoOptionVariantId();

      fontSwatches.forEach((btn) => {
        btn.addEventListener('click', () => {
          fontSwatches.forEach((b) => {
            b.classList.remove('active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-checked', 'true');
          currentFontLabel = btn.getAttribute('data-mtl-font') || 'Romantic';
          if (fontInput) fontInput.value = currentFontLabel;
          applyFontToPreview(btn);
          // Re-flow the SVG text now that font metrics changed.
          if (typeof updateName === 'function') updateName();
          syncTwoOptionVariantId();
        });
      });

      // Also re-sync the variant id when a finish swatch changes — wrap the
      // existing metal swatch click effect via an extra capture-phase listener.
      root.querySelectorAll('[data-mtl-swatch]').forEach((btn) => {
        btn.addEventListener('click', () => {
          // currentMetal is set by the legacy handler above; defer one tick so
          // it has run before we sync the variant id.
          setTimeout(syncTwoOptionVariantId, 0);
        });
      });
    }

    function applyFontToPreview(swatchEl) {
      if (!nameText || !swatchEl) return;
      const family = swatchEl.getAttribute('data-font-family') || 'Dancing Script';
      const weight = swatchEl.getAttribute('data-font-weight') || '600';
      // Use style.setProperty with !important so Horizon's global text styling
      // can't win the cascade (same pattern as the .grid override).
      nameText.style.setProperty('font-family', "'" + family + "', 'Montserrat', sans-serif", 'important');
      nameText.style.setProperty('font-weight', weight, 'important');
      // 2026-09-21: per-font size/width matched to that font's engraving partner template.
      const bs = parseInt(swatchEl.getAttribute('data-base-size') || '', 10);
      const mw = parseInt(swatchEl.getAttribute('data-max-width') || '', 10);
      if (bs) BASE_SIZE = bs;
      if (mw) MAX_WIDTH = mw;
      // Minimalist (Antonio) is narrower; bump font-size a bit so engraving
      // looks visually balanced with the other two cursive/serif options.
      // Remember the template's own letter-spacing (engraving_letter_spacing) so switching
      // fonts restores it instead of falling back to the stylesheet's .04em.
      if (nameText.dataset.lsDefault === undefined) nameText.dataset.lsDefault = nameText.style.getPropertyValue('letter-spacing') || '';
      if (family === 'Antonio') {
        nameText.style.setProperty('letter-spacing', '0.04em', 'important');
      } else if (nameText.dataset.lsDefault) {
        nameText.style.setProperty('letter-spacing', nameText.dataset.lsDefault, 'important');
      } else {
        nameText.style.removeProperty('letter-spacing');
      }
    }
    /* ==================================================================== */

    /* --- name input: filter + shrink-to-fit + counter + ATC state --- */
    function updateName() {
      if (!nameInput || !nameText) return;
      const raw = nameInput.value.replace(/\s+/g, ' ').trim();
      currentName = raw;
      const display = raw ? (FORCE_UPPER ? raw.toUpperCase() : raw) : (root.dataset.previewDefault || (FORCE_UPPER ? 'MAX' : 'Max'));
      nameText.textContent = display;

      // Shrink-to-fit: iterate font-size down until text fits bounding box
      let fontSize = BASE_SIZE;
      nameText.setAttribute('font-size', fontSize);
      let guard = 0;
      while (nameText.getComputedTextLength && nameText.getComputedTextLength() > MAX_WIDTH && fontSize > MIN_SIZE && guard < 60) {
        fontSize -= 2;
        nameText.setAttribute('font-size', fontSize);
        guard++;
      }
      // 2026-09-21: engraving partner centers its text box (the font's line box) vertically,
      // so shrunk names rise toward the middle. Opt-in per template (text_valign = middle).
      // Font-agnostic: keep the line-box centre where it is at full size.
      if (root.dataset.valign === 'middle' && nameText.getBBox) {
        if (!nameText.dataset.baseY) nameText.dataset.baseY = nameText.getAttribute('y');
        const y0 = parseFloat(nameText.dataset.baseY);
        try {
          nameText.setAttribute('y', y0);
          const cur = nameText.getBBox();
          const ratio = fontSize / BASE_SIZE;
          // line box scales with font size about the baseline: centre offset shrinks by ratio
          const centreOffset = (cur.y + cur.height / 2) - y0;          // at current size
          const fullOffset = centreOffset / (ratio || 1);                // at full size
          nameText.setAttribute('y', (y0 + fullOffset - centreOffset).toFixed(1));
        } catch (e) {}
      }

      /* MTL 2026-07-26: dual-necklace composite previews render the same name
         on a SECOND engraving zone (Cat/Dog Paw slider). No-op on every other
         template (element absent). Per-zone size/width via data attributes. */
      const nameText2 = root.querySelector('[data-mtl="name-text-2"]');
      if (nameText2) {
        nameText2.textContent = display;
        let fs2 = parseInt(nameText2.getAttribute('data-base-size') || BASE_SIZE, 10) || BASE_SIZE;
        const mw2 = parseInt(nameText2.getAttribute('data-max-width') || MAX_WIDTH, 10) || MAX_WIDTH;
        nameText2.setAttribute('font-size', fs2);
        let g2 = 0;
        while (nameText2.getComputedTextLength && nameText2.getComputedTextLength() > mw2 && fs2 > MIN_SIZE && g2 < 60) {
          fs2 -= 2;
          nameText2.setAttribute('font-size', fs2);
          g2++;
        }
      }

      if (counter) {
        counter.textContent = raw.length + ' / ' + MAX_LEN;
        counter.classList.remove('warn', 'limit');
        if (raw.length >= MAX_LEN) counter.classList.add('limit');
        else if (raw.length >= MAX_LEN - 2) counter.classList.add('warn');
      }

      if (atcBtn) {
        if (raw.length === 0) {
          atcBtn.textContent = 'Name your necklace below';
          atcBtn.disabled = true;
        } else {
          const properCase = FORCE_UPPER ? (raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase()) : raw;
          if (!FORCE_UPPER) {
            atcBtn.textContent = 'Add to Cart — ';
            const s = document.createElement('span');
            s.className = 'mtl-atc-name';
            s.style.setProperty('text-transform', 'none', 'important');
            s.style.setProperty('pointer-events', 'none');
            s.textContent = properCase;
            atcBtn.appendChild(s);
            atcBtn.appendChild(document.createTextNode(' · ' + PRICE));
          } else {
            atcBtn.textContent = 'Add to Cart — ' + properCase + ' · ' + PRICE;
          }
          atcBtn.disabled = false;
        }
      }
    }

    if (nameInput) {
      // ALWAYS start with an empty input. No cross-product memory — customers
      // were seeing test names pre-populated which looked like a bug.
      // Also wipe any stale localStorage entry from prior code.
      try { localStorage.removeItem('mtl_pet_name'); } catch (_) {}
      nameInput.value = '';
      nameInput.setAttribute('autocomplete', 'off');
      nameInput.setAttribute('autocorrect', 'off');
      nameInput.setAttribute('autocapitalize', FORCE_UPPER ? 'characters' : 'words');
      nameInput.setAttribute('spellcheck', 'false');
      // 2026-09-21: caps-only SKUs (uppercase_input) store real capitals so the
      // cart/order line matches the engraving (was: typed 'jm' shown, 'JM' engraved).
      if (root.dataset.uppercaseInput === 'true') {
        nameInput.addEventListener('input', () => {
          const v = nameInput.value, up = v.toUpperCase();
          if (v !== up) {
            const s = nameInput.selectionStart, e = nameInput.selectionEnd;
            nameInput.value = up;
            try { nameInput.setSelectionRange(s, e); } catch (_) {}
          }
        }, true);
        const f = nameInput.form;
        if (f) f.addEventListener('submit', () => { nameInput.value = nameInput.value.toUpperCase(); }, true);
      }
      // Randomize the name attribute so browsers can't match history by name.
      // We restore the canonical property name at submit-time below.
      const CANONICAL_NAME = nameInput.getAttribute('name') || 'properties[Make It Yours]';
      nameInput.dataset.canonicalName = CANONICAL_NAME;
      nameInput.setAttribute('name', 'mtl-pet-' + Math.random().toString(36).slice(2, 10));

      nameInput.addEventListener('input', (e) => {
        window.MTLEngraveClean(e.target);
        updateName();
      });
      // Restore canonical name just before form submit so the fulfiller receives properties[Make It Yours]
      const form = nameInput.closest('form');
      if (form) {
        form.addEventListener('submit', () => {
          nameInput.setAttribute('name', CANONICAL_NAME);
        }, true);  // capture phase so it runs before any other submit handler
      }
      updateName();
    }

    /* --- gift toggle --- */
    if (isGift && giftWrap) {
      isGift.addEventListener('change', () => {
        giftWrap.setAttribute('data-show', isGift.checked ? 'true' : 'false');
        if (isGift.checked && giftMessage) setTimeout(() => giftMessage.focus(), 120);
      });
    }
    if (giftMessage && giftCounter) {
      giftMessage.addEventListener('input', () => {
        giftCounter.textContent = giftMessage.value.length + ' / 220';
      });
    }

    /* --- mockup lightbox --- */
    if (lightbox) {
      // Move lightbox to document.body so it escapes .media's sticky stacking context
      if (lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }
      // Force hidden by default + max z-index + premium overlay via inline style
      lightbox.style.setProperty('display', 'none', 'important');  // ← HIDDEN by default
      lightbox.style.setProperty('z-index', '99999', 'important');
      lightbox.style.setProperty('position', 'fixed', 'important');
      lightbox.style.setProperty('inset', '0', 'important');
      lightbox.style.setProperty('background', 'rgba(26,26,26,.95)', 'important');
      lightbox.style.setProperty('backdrop-filter', 'blur(6px)', 'important');
      lightbox.style.setProperty('-webkit-backdrop-filter', 'blur(6px)', 'important');
      lightbox.style.setProperty('padding', '40px 20px', 'important');
      lightbox.style.setProperty('align-items', 'center', 'important');
      lightbox.style.setProperty('justify-content', 'center', 'important');

      // Style the lightbox IMAGE directly (CSS rule is scoped to .mtl-p but lightbox was moved to body).
      // Without these, object-fit defaults to 'fill' and max-height is 'none' → image zooms way in.
      if (lightboxImg) {
        lightboxImg.style.setProperty('max-width', '90vw', 'important');
        lightboxImg.style.setProperty('max-height', '85vh', 'important');
        lightboxImg.style.setProperty('width', 'auto', 'important');
        lightboxImg.style.setProperty('height', 'auto', 'important');
        lightboxImg.style.setProperty('object-fit', 'contain', 'important');
        lightboxImg.style.setProperty('border-radius', '12px', 'important');
        lightboxImg.style.setProperty('box-shadow', '0 20px 60px rgba(0,0,0,.5)', 'important');
        lightboxImg.style.setProperty('display', 'block', 'important');
      }

      // Style the prev/next arrows + counter (scoped CSS doesn't reach these since lightbox is in body)
      const arrowBaseStyle = {
        position: 'fixed',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '44px',
        height: '44px',
        background: 'rgba(255,255,255,.15)',
        backdropFilter: 'blur(10px)',
        webkitBackdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,.2)',
        borderRadius: '50%',
        color: '#fff',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '100000',
        padding: '0',
        transition: 'background-color 160ms ease, transform 160ms ease'
      };
      [document.querySelector('[data-mtl="lightbox-prev"]'), document.querySelector('[data-mtl="lightbox-next"]')].forEach((arrow) => {
        if (!arrow) return;
        Object.entries(arrowBaseStyle).forEach(([k, v]) => {
          const cssKey = k.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
          arrow.style.setProperty(cssKey, v, 'important');
        });
      });
      const lbPrevBtn = document.querySelector('[data-mtl="lightbox-prev"]');
      const lbNextBtn = document.querySelector('[data-mtl="lightbox-next"]');
      if (lbPrevBtn) lbPrevBtn.style.setProperty('left', '16px', 'important');
      if (lbNextBtn) lbNextBtn.style.setProperty('right', '16px', 'important');
      // Counter: bottom-centered pill with "1 / 4" format
      const lbCounterEl = document.querySelector('[data-mtl="lightbox-counter"]');
      if (lbCounterEl) {
        lbCounterEl.style.setProperty('position', 'fixed', 'important');
        lbCounterEl.style.setProperty('bottom', '32px', 'important');
        lbCounterEl.style.setProperty('left', '50%', 'important');
        lbCounterEl.style.setProperty('transform', 'translateX(-50%)', 'important');
        lbCounterEl.style.setProperty('background', 'rgba(255,255,255,.15)', 'important');
        lbCounterEl.style.setProperty('backdrop-filter', 'blur(10px)', 'important');
        lbCounterEl.style.setProperty('-webkit-backdrop-filter', 'blur(10px)', 'important');
        lbCounterEl.style.setProperty('color', '#fff', 'important');
        lbCounterEl.style.setProperty('font-family', "'Inter', sans-serif", 'important');
        lbCounterEl.style.setProperty('font-size', '12px', 'important');
        lbCounterEl.style.setProperty('font-weight', '600', 'important');
        lbCounterEl.style.setProperty('letter-spacing', '.1em', 'important');
        lbCounterEl.style.setProperty('padding', '6px 14px', 'important');
        lbCounterEl.style.setProperty('border-radius', '999px', 'important');
        lbCounterEl.style.setProperty('z-index', '100000', 'important');
      }

      // Close (X) button: match the arrow styling so it's easy to see + tap. Pin to top-right.
      if (lightboxClose) {
        lightboxClose.style.setProperty('position', 'fixed', 'important');
        lightboxClose.style.setProperty('top', '20px', 'important');
        lightboxClose.style.setProperty('right', '20px', 'important');
        lightboxClose.style.setProperty('width', '44px', 'important');
        lightboxClose.style.setProperty('height', '44px', 'important');
        lightboxClose.style.setProperty('background', 'rgba(255,255,255,.15)', 'important');
        lightboxClose.style.setProperty('backdrop-filter', 'blur(10px)', 'important');
        lightboxClose.style.setProperty('-webkit-backdrop-filter', 'blur(10px)', 'important');
        lightboxClose.style.setProperty('border', '1px solid rgba(255,255,255,.2)', 'important');
        lightboxClose.style.setProperty('border-radius', '50%', 'important');
        lightboxClose.style.setProperty('color', '#fff', 'important');
        lightboxClose.style.setProperty('font-size', '20px', 'important');
        lightboxClose.style.setProperty('font-weight', '400', 'important');
        lightboxClose.style.setProperty('font-family', 'system-ui, sans-serif', 'important');
        lightboxClose.style.setProperty('line-height', '1', 'important');
        lightboxClose.style.setProperty('cursor', 'pointer', 'important');
        lightboxClose.style.setProperty('display', 'flex', 'important');
        lightboxClose.style.setProperty('align-items', 'center', 'important');
        lightboxClose.style.setProperty('justify-content', 'center', 'important');
        lightboxClose.style.setProperty('padding', '0', 'important');
        lightboxClose.style.setProperty('z-index', '100001', 'important');
        lightboxClose.style.setProperty('transition', 'background-color 160ms ease', 'important');
      }

      // Collect all lightbox-able mockups into an array for nav (prev/next, swipe, keyboard)
      const lbMockups = Array.from(root.querySelectorAll('[data-mtl="mockup-thumb"][data-src]'));
      let lbIndex = 0;

      const lbPrev = document.querySelector('[data-mtl="lightbox-prev"]');
      const lbNext = document.querySelector('[data-mtl="lightbox-next"]');
      const lbCounter = document.querySelector('[data-mtl="lightbox-counter"]');

      // Hide nav entirely if only 0 or 1 mockups exist
      const showNav = lbMockups.length > 1;
      if (!showNav) {
        if (lbPrev) lbPrev.style.setProperty('display', 'none', 'important');
        if (lbNext) lbNext.style.setProperty('display', 'none', 'important');
        if (lbCounter) lbCounter.style.setProperty('display', 'none', 'important');
      }

      function showMockupAt(index) {
        if (!lbMockups.length) return;
        // Wrap-around: -1 → last, length → 0
        lbIndex = ((index % lbMockups.length) + lbMockups.length) % lbMockups.length;
        const btn = lbMockups[lbIndex];
        if (lightboxImg) {
          lightboxImg.src = btn.getAttribute('data-src');
          lightboxImg.alt = btn.getAttribute('aria-label') || 'Product view';
          // Re-apply sizing in case image was replaced/reset
          lightboxImg.style.setProperty('max-width', '90vw', 'important');
          lightboxImg.style.setProperty('max-height', '85vh', 'important');
          lightboxImg.style.setProperty('width', 'auto', 'important');
          lightboxImg.style.setProperty('height', 'auto', 'important');
          lightboxImg.style.setProperty('object-fit', 'contain', 'important');
        }
        if (lbCounter && showNav) lbCounter.textContent = (lbIndex + 1) + ' / ' + lbMockups.length;
      }

      function openLightbox(index) {
        showMockupAt(index);
        lightbox.setAttribute('data-show', 'true');
        lightbox.style.setProperty('display', 'flex', 'important');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lightbox.removeAttribute('data-show');
        lightbox.style.setProperty('display', 'none', 'important');
        document.body.style.overflow = '';
      }

      // 2026-05-30: Thumb clicks now SWAP an inline overlay on the pendant area
      //   (no full-screen modal). Click the swapped image to open the lightbox for
      //   true zoom; click the LIVE preview thumb (or the close button on overlay)
      //   to return to the live engraving preview.
      // Reasoning: full-screen modal felt heavy on mobile (owner feedback).
      // Standard jewelry PDP pattern - thumb swap inline, main
      //   image click opens zoom.
      (function setupInlineSwap() {
        const pendantImgWrap = root.querySelector('.pendant-img-wrap') || root.querySelector('.pendant-wrap');
        const liveThumb = root.querySelector('.mockup-thumb.live-indicator')
                       || root.querySelector('button.mockup-thumb:not([data-src])');
        if (!pendantImgWrap) {
          // Fallback: keep legacy lightbox behavior if pendant area not found.
          lbMockups.forEach((btn, i) => {
            btn.addEventListener('click', (e) => { e.preventDefault(); openLightbox(i); });
          });
          return;
        }

        // Build (idempotent) the overlay <img> that sits on top of the live preview.
        let overlay = pendantImgWrap.querySelector('.mtl-mockup-overlay');
        if (!overlay) {
          overlay = document.createElement('img');
          overlay.className = 'mtl-mockup-overlay';
          overlay.style.cssText = [
            'position:absolute',
            'inset:0',
            'width:100%',
            'height:100%',
            'object-fit:cover',
            'object-position:center',
            'background:#fff',
            'display:none',
            'cursor:zoom-in',
            'z-index:5',
            'border-radius:inherit'
          ].join(';');
          overlay.setAttribute('data-mtl', 'mockup-overlay');
          // Ensure parent is a positioned container
          if (getComputedStyle(pendantImgWrap).position === 'static') {
            pendantImgWrap.style.position = 'relative';
          }
          pendantImgWrap.appendChild(overlay);
          // Click the swapped image → open lightbox for explicit zoom
          overlay.addEventListener('click', () => {
            const idx = lbMockups.findIndex(b => b.getAttribute('data-src') === overlay.dataset.currentSrc);
            if (idx >= 0) openLightbox(idx);
          });
        }

        function showOverlay(btn) {
          const src = btn.getAttribute('data-src');
          if (!src) return;
          overlay.src = src;
          overlay.alt = btn.getAttribute('aria-label') || 'Product view';
          overlay.dataset.currentSrc = src;
          overlay.style.display = '';
          // Mark this thumb active, unmark others
          lbMockups.forEach(b => b.classList.toggle('active', b === btn));
          if (liveThumb) liveThumb.classList.remove('active');
        }

        function hideOverlay() {
          overlay.style.display = 'none';
          overlay.removeAttribute('data-current-src');
          // Restore LIVE thumb active
          if (liveThumb) liveThumb.classList.add('active');
          lbMockups.forEach(b => b.classList.remove('active'));
        }

        // MTL 2026-07-28 (gallery-fix): tap a mockup thumb → open the full-screen
        // lightbox AT that image; all mockups are swipeable inside. One tap to a big,
        // zoomable view — matches premium jewelry PDPs. The Live Preview tile in
        // position 1 is never overlaid or disturbed. (Supersedes the earlier inline
        // overlay-swap so customers can see EVERY mockup, full-screen, in one tap.)
        lbMockups.forEach((btn, i) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            openLightbox(i);
          });
        });

        // LIVE preview thumb → restore live engraved preview
        if (liveThumb) {
          liveThumb.addEventListener('click', (e) => {
            e.preventDefault();
            hideOverlay();
          });
        }
      })();

      // Arrow navigation
      if (lbPrev) lbPrev.addEventListener('click', (e) => { e.stopPropagation(); showMockupAt(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', (e) => { e.stopPropagation(); showMockupAt(lbIndex + 1); });

      // Close: X button, backdrop click, Escape key
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', (e) => {
        if (lightbox.getAttribute('data-show') !== 'true') return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft' && showNav) showMockupAt(lbIndex - 1);
        else if (e.key === 'ArrowRight' && showNav) showMockupAt(lbIndex + 1);
      });

      // Touch swipe support on mobile — natural gesture to flip between mockups
      if (showNav) {
        let touchStartX = 0, touchStartY = 0;
        lightbox.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        lightbox.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          // Require horizontal motion > vertical + minimum threshold to avoid vertical-scroll misfires
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            if (dx < 0) showMockupAt(lbIndex + 1);  // swipe left → next
            else showMockupAt(lbIndex - 1);         // swipe right → prev
          }
        }, { passive: true });
      }

      // MTL 2026-07-28 (gallery-fix): tap-to-zoom inside the lightbox. Double-tap
      // (mobile) or double-click (desktop) toggles a 2.3x zoom centered on the tap
      // point; zoom resets on next/prev, close, backdrop tap, and Escape. Reliable
      // across viewports (does not depend on the page allowing native pinch).
      if (lightboxImg) {
        let lbZoomed = false;
        const setZoom = (on, ox, oy) => {
          lbZoomed = on;
          if (on) {
            if (ox != null) lightboxImg.style.transformOrigin = ox + '% ' + oy + '%';
            lightboxImg.style.setProperty('transform', 'scale(2.3)', 'important');
            lightboxImg.style.setProperty('cursor', 'zoom-out', 'important');
          } else {
            lightboxImg.style.setProperty('transform', 'none', 'important');
            lightboxImg.style.transformOrigin = 'center center';
            lightboxImg.style.setProperty('cursor', 'zoom-in', 'important');
          }
        };
        lightboxImg.style.setProperty('cursor', 'zoom-in', 'important');
        lightboxImg.style.setProperty('transition', 'transform 200ms ease', 'important');
        lightboxImg.addEventListener('dblclick', (e) => {
          e.preventDefault();
          const r = lightboxImg.getBoundingClientRect();
          setZoom(!lbZoomed, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
        });
        let lbLastTap = 0;
        lightboxImg.addEventListener('touchend', (e) => {
          const now = Date.now();
          if (now - lbLastTap < 300 && e.changedTouches.length) {
            const t = e.changedTouches[0];
            const r = lightboxImg.getBoundingClientRect();
            setZoom(!lbZoomed, ((t.clientX - r.left) / r.width) * 100, ((t.clientY - r.top) / r.height) * 100);
            e.preventDefault();
          }
          lbLastTap = now;
        }, { passive: false });
        const resetZoom = () => { if (lbZoomed) setZoom(false); };
        if (lbPrev) lbPrev.addEventListener('click', resetZoom);
        if (lbNext) lbNext.addEventListener('click', resetZoom);
        if (lightboxClose) lightboxClose.addEventListener('click', resetZoom);
        lightbox.addEventListener('click', (e) => { if (e.target === lightbox) resetZoom(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') resetZoom(); });
      }
    }

    /* --- "See engraving close-up" link (to the preview hub) --- */
    const seeReal = root.querySelector('[data-mtl="see-real"]');
    if (seeReal) {
      seeReal.addEventListener('click', (e) => {
        e.preventDefault();
        const previewUrl = root.dataset.previewHubUrl;
        if (previewUrl) {
          window.open(previewUrl + '?name=' + encodeURIComponent(currentName || 'MAX'), '_blank', 'noopener');
        } else {
          alert('Real-metal preview opens here once the preview URL is configured in section settings.');
        }
      });
    }
  }

  /* Initialize all MTL sections on the page */
  function boot() {
    document.querySelectorAll('.mtl-p').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

